import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const MobileContext = createContext();

const MobileProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const value = {
    isOpen,
    changeOpen: () => {
      setIsOpen(!isOpen);
    },
  };

  return (
    <MobileContext.Provider value={value}>
      { children }
    </MobileContext.Provider>
  );
};

MobileProvider.propTypes = propTypes;

export {
  MobileContext,
  MobileProvider,
};
